import { render, staticRenderFns } from "./UserCompPage.vue?vue&type=template&id=23686f5c&scoped=true"
import script from "./UserCompPage.vue?vue&type=script&lang=js"
export * from "./UserCompPage.vue?vue&type=script&lang=js"
import style0 from "./UserCompPage.vue?vue&type=style&index=0&id=23686f5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23686f5c",
  null
  
)

export default component.exports